"use strict";
/**
 * @param {string}  color - A string param (the color to opacify).
 * @param {number} opacityLevel - An number param (How mush you want to opacify the color, Ex: 0.5, Default value is 1 which means no opacity at all)
 * @returns {string} the opacified color
 */
Object.defineProperty(exports, "__esModule", { value: true });
var addOpacity = function (color, opacityLevel) {
    // if it has an alpha, remove it
    if (color.length > 7)
        color = color.substring(0, color.length - 2);
    var _opacity = Math.round(Math.min(Math.max(opacityLevel || 1, 0), 1) * 255);
    var opacityHex = _opacity.toString(16).toUpperCase();
    // opacities near 0 need a trailing 0
    if (opacityHex.length === 1)
        opacityHex = "0" + opacityHex;
    return color + opacityHex;
};
exports.default = addOpacity;
